import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import Spinner from "../../components/Spinner";
import { RootState } from "../../redux/rootReducers";
import { useDispatch, useSelector } from "react-redux";
import FormSearch from "../../components/forms/FormSearch";
import PageWrapper from "../../components/layouts/PageWrapper";
import { DataTableWrapper } from "../../components/data/DataTable";
import { parseStringToSeries } from "../../helpers/fieldHelper";
import { getUserAsync } from "../../redux/reducers/users/users.actions";
import Button from "../../components/forms/ButtonEx";

const UsersPage = () => {
  const dispatch = useDispatch();

  const users = useSelector((state: RootState) => state.user.users);
  const isLoading = useSelector((state: RootState) => state.user.isLoading);

  useEffect(() => {
    dispatch(getUserAsync.request({}));
  }, []);

  const renderUserList = () => {
    if (isLoading) {
      return (
        <tr>
          <td colSpan={6} className="tablewrapper--loading">
            <div className="tablewrapper--loading--caption">
              <Spinner size="small" />
              <span>Memuat data...</span>
            </div>
          </td>
        </tr>
      );
    }

    if (users.length > 0) {
      return users.map(user => {
        return (
          <tr>
            <td><Link to={`/master-data/users/${user.id}`}>{user.name}</Link></td>
            <td>{user.email}</td>
            <td>{parseStringToSeries(user.phone_number, 4)}</td>
          </tr>
        );
      })
    } else {
      return (
        <tr>
          <td colSpan={7}>No user data was found</td>
        </tr>
      );
    }
  }

  return (
    <PageWrapper>
      <div>
        <DataTableWrapper>
          <div className="tablewrapper--title">
            Saring Pengguna
          </div>
          <div className="tablewrapper--table">
            <table>
              <thead>
                <tr>
                  <th>Nama</th>
                  <th>Email</th>
                  <th>Nomor Telepon</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <FormSearch />
                  </td>
                  <td>
                    <FormSearch />
                  </td>
                  <td>
                    <FormSearch />
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <div className="tablewrapper--action">
                      <Button size="small" caption="Cari" noBlock />
                      <a href="/users/create">
                        <Button size="small" caption="Buat Baru" noBlock />
                      </a>
                      <Button size="small" caption="Impor Excel" noBlock />
                      <Button size="small" caption="Export" noBlock />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </DataTableWrapper>
        <DataTableWrapper>
          <div className="tablewrapper--title">
            Daftar Pengguna
          </div>
          <div className="tablewrapper--table">
            <table>
              <thead>
                <tr>
                  <th>Nama</th>
                  <th>Email</th>
                  <th>Nomor Telepon</th>
                </tr>
              </thead>
              <tbody>
                {renderUserList()}
              </tbody>
            </table>
          </div>
          <div className="tablewrapper--pagination">
            <Link className="active" to={`/master-data/users?page=1`}>Pertama</Link>
            <Link className="active" to={`/master-data/users?page=1`}>1</Link>
            <Link to={`/master-data/users?page=2`}>2</Link>
            <Link to={`/master-data/users?page=3`}>3</Link>
            <Link to={`/master-data/users?page=4`}>4</Link>
            <Link to={`/master-data/users?page=4`}>Terakhir</Link>
          </div>
        </DataTableWrapper>
      </div>
    </PageWrapper>
  );
}

export default UsersPage;